import React, { useState } from "react";
import "./EtudesPage.css";
import InfoCard from "../../components/ui/InfoCard/InfoCard";
import AddCard from "../../components/ui/AddCard/AddCard";
import EditStudy from "../../components/Study/EditStudy/EditStudy";
import { FaUniversity } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import NewStudy from "../../components/Study/NewStudy/NewStudy";
import Spinner from "../../components/ui/Spinner/Spinner";
import { useStudies } from "../../hooks/useStudies";
import { studiesService } from "../../service";
import { toast } from "react-toastify";
import ConfirmDeleteModal from "../../components/ui/ConfirmDeleteModal/ConfirmDeleteModal";

const EtudesPage = () => {
  const navigate = useNavigate();
  const {
    studies,
    loading,
    error,
    showNewStudy,
    handleAddClick,
    handleBack,
    refreshStudies,
  } = useStudies();

  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedStudy, setSelectedStudy] = useState(null);

  const goToDetails = (studyId) => navigate(`/etudes-Details/${studyId}`);

  const handleDeleteClick = (study) => {
    setSelectedStudy(study);
    setShowConfirm(true);
  };

  const [showEdit, setShowEdit] = useState(false);
  const [studyToEdit, setStudyToEdit] = useState(null);

  const handleEditClick = (study) => {
    setStudyToEdit(study);
    setShowEdit(true);
  };

  const handleCloseEdit = async (shouldRefresh) => {
    setShowEdit(false);
    setStudyToEdit(null);
    if (shouldRefresh) await refreshStudies();
  };

  const handleConfirmDelete = async () => {
    try {
      if (!selectedStudy) return;
      await studiesService.delete(selectedStudy.id);
      toast.success(`Étude "${selectedStudy.name}" supprimée avec succès.`);
      await refreshStudies();
    } catch (err) {
      console.error("Erreur suppression:", err);
      toast.error("Échec de la suppression de l'étude.");
    } finally {
      setShowConfirm(false);
      setSelectedStudy(null);
    }
  };

  if (loading) return <Spinner size="lg" />;

  return (
    <main className="content flex-grow-1 p-4 ms-2 mt-3">
      {showNewStudy ? (
        <NewStudy onBack={handleBack} />
      ) : (
        <div className="overflow-y-auto px-0" style={{ height: "100%" }}>
          <div className="container-fluid">
            <div className="row g-3">
              {/* Add New Study Card */}
              <div className="col-12 col-sm-6 col-md-4 col-lg-3 etude-card">
                <AddCard title="Nouvelle étude" onADD={handleAddClick} />
              </div>

              {/* Error message */}
              {error && (
                <div className="col-12">
                  <p className="text-danger">{error}</p>
                </div>
              )}

              {/* Studies list */}
              {studies.length > 0
                ? studies.map((study) => (
                    <div
                      key={study.id}
                      className="col-12 col-sm-6 col-md-4 col-lg-3"
                    >
                      <InfoCard
                        title={study.name}
                        Icon={FaUniversity}
                        actionType="Formulaires"
                        count={study.forms?.length || 0}
                        unit="Formulaires"
                        onClick={() =>
                          navigate(`/etudes-Details/${study.id}`, {
                            state: { tab: "forms" },
                          })
                        }
                        onStatsClick={() => goToDetails(study.id)}
                        options={[
                          {
                            label: "Modifier",
                            onClick: () => handleEditClick(study),
                          },
                          {
                            label: "Supprimer",
                            onClick: () => handleDeleteClick(study),
                          },
                        ]}
                      />
                    </div>
                  ))
                : !error && (
                    <div className="col-12 text-center mt-4">
                      <p>Aucune étude trouvée.</p>
                    </div>
                  )}
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      <ConfirmDeleteModal
        show={showConfirm}
        type={"l'étude"}
        studyName={selectedStudy?.name}
        onClose={() => setShowConfirm(false)}
        onConfirm={handleConfirmDelete}
      />
      <EditStudy
        show={showEdit}
        onClose={handleCloseEdit}
        study={studyToEdit}
      />
    </main>
  );
};

export default EtudesPage;
